import React from "react";
import { Button, DatePicker, Input, Select } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import Icons from "components/icons";
import { Localize } from "components/service";


const { RangePicker } = DatePicker;
const { Search } = Input;
const lifecycleStatuses = [ "all", "live", "construction", "upcoming", "past" ];

const StaffManagementTableFilter = ({
    searchText,
    setSearchText,
    lifecycleStatus,
    setLifecycleStatus,
    constructionPeriod,
    setConstructionPeriod,
    exhibitionPeriod,
    setExhibitionPeriod,
    resetPage,
}) => {
    const hasConstructionPeriod = !!constructionPeriod?.length;
    const hasExhibitionPeriod = !!exhibitionPeriod?.length;
    const hasFilters = !!(
        searchText ||
        lifecycleStatus ||
        hasConstructionPeriod ||
        hasExhibitionPeriod
    );

    const clearFilters = () => {
        setSearchText("");
        setLifecycleStatus(undefined);
        setConstructionPeriod([]);
        setExhibitionPeriod([]);
        resetPage();
    };

    return (
        <div className="d-flex align-items-center table-action-bar form-controls-compact staff-table-filter staff-table-filter--list">
            <div className="d-flex align-items-center table-filter-form staff-table-filter__controls">
                <Search
                    allowClear={ { clearIcon: <CloseOutlined /> } }
                    className="filter-search"
                    prefix={ <SearchOutlined /> }
                    placeholder={ Localize({ children: "STAFF_MANAGEMENT.Filter_SearchExhibition" }).props.children }
                    value={ searchText }
                    onChange={ (event) => {
                        setSearchText(event.target.value);
                        resetPage();
                    } } />

                <Select
                    className="staff-management-list__status-filter"
                    suffixIcon={ <Icons.Arrow /> }
                    value={ lifecycleStatus || "all" }
                    onChange={ (value) => {
                        setLifecycleStatus(value === "all" ? undefined : value);
                        resetPage();
                    } }
                    options={ lifecycleStatuses.map((status) => ({
                        value: status,
                        label: Localize({
                            children: status === "all" ?
                                "STAFF_MANAGEMENT.Filter_AllStatuses" :
                                `STAFF_MANAGEMENT.Status_${ status }`
                        }).props.children,
                    })) } />

                <RangePicker
                    allowClear
                    clearIcon={ <CloseOutlined /> }
                    className={ `staff-management-list__period-filter${
                        hasConstructionPeriod ?
                            " staff-management-list__period-filter--chosen staff-filter-control--selected" :
                            " range-picker-single-placeholder"
                    }` }
                    format="DD.MM.YYYY"
                    separator="-"
                    suffixIcon={ hasConstructionPeriod ? null : <Icons.StaffCalendar /> }
                    placeholder={ [
                        Localize({ children: "STAFF_MANAGEMENT.Filter_ConstructionPeriod" }).props.children,
                        "",
                    ] }
                    value={ hasConstructionPeriod ? constructionPeriod : undefined }
                    onChange={ (value) => {
                        setConstructionPeriod(value || []);
                        resetPage();
                    } } />

                <RangePicker
                    allowClear
                    clearIcon={ <CloseOutlined /> }
                    className={ `staff-management-list__period-filter staff-management-list__period-filter--exhibition${
                        hasExhibitionPeriod ?
                            " staff-management-list__period-filter--chosen staff-filter-control--selected" :
                            " range-picker-single-placeholder"
                    }` }
                    format="DD.MM.YYYY"
                    separator="-"
                    suffixIcon={ hasExhibitionPeriod ? null : <Icons.StaffCalendar /> }
                    placeholder={ [
                        Localize({ children: "STAFF_MANAGEMENT.Filter_ExhibitionPeriod" }).props.children,
                        "",
                    ] }
                    value={ hasExhibitionPeriod ? exhibitionPeriod : undefined }
                    onChange={ (value) => {
                        setExhibitionPeriod(value || []);
                        resetPage();
                    } } />

                { hasFilters &&
                    <Button className="btn-text-link" type="link" onClick={ clearFilters }>
                        <Localize>STAFF_MANAGEMENT.Action_ClearAll</Localize>
                    </Button>
                }
            </div>
        </div>
    );
};

export default StaffManagementTableFilter;
